import Vue from 'vue'
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from 'vee-validate/dist/vee-validate.full';
import VueScrollTo from 'vue-scrollto';

import App from './App.vue'
import router from './router'
import store from './store'

import './copy'


Vue.config.productionTip = false

extend('postcode', {
  validate: value => value.match(/([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/g)
});
extend('creditcard', {
  validate: value => value.match(/^\d{4}([ -]?)((\d{6}\1?\d{5})|(\d{4}\1?\d{4}\1?\d{4}))$/g)
});
extend('future', {
  params: ['target'],
  validate(value, {
    target
  }) {
    const d = new Date();
    const currentMm = d.getMonth() + 1;
    const currentYy = parseInt(
      d
      .getFullYear()
      .toString()
      .slice(2, 4)
    );
    console.log(target)
    console.log(value)
    if (target <= currentYy) {
      if (value < currentMm) {
        console.log('INVALID')
        return false;
      } else {
        return true;
      }
    }
    return true;
  },
  message: 'Please enter a date in the future'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.use(VueScrollTo)

Vue.mixin({
  methods: {
    gotoSlide(id) {
      this.$store.commit('addSlide', id)

      if (id === 'share') {
        this.$store.commit('updateShareDescription', {
          shareDesc: this.$store.state.copy.meta.whatsapp.replace('[SCORE]', this.$store.getters.getScore)
        })
      }

      setTimeout(() => {
        this.$scrollTo('#' + id)
      }, 250)
    },
    analytics(eventName, eventValue) {
      window.dataLayer = window.dataLayer || [];

      if (typeof eventValue === 'object' && eventValue !== null) {
        // Spread the properties of eventValue into the dataLayer event
        window.dataLayer.push({
          event: eventName,
          ...eventValue
        });
      } else {
        // If eventValue is not an object, use it as it is
        window.dataLayer.push({
          event: eventName,
          eventValue: eventValue
        });
      }
    },
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')